import React, { useEffect, useRef } from "react";
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Container,
  Grid2,
  IconButton,
  Paper,
  Typography,
  useMediaQuery,
} from "@mui/material";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineSeparator,
} from "@mui/lab";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
// import wave from "../../../Images/wave.svg";

import Lottie from "lottie-react";
import HomeAnimation from "../../../Images/homeAnimation.json";
import contactusHomePage from "../../../Images/contactusHomePage.json";
// import internet from "../../../Images/IPB/image3.png";
// import eam from "../../../Images/EAM/Dashboard.png";
// import walk from "../../../Images/safetyWalk/dashboard.png";
// import e_Form from "../../../Images/e-Form/dashboard.png";
// import ptw from "../../../Images/PTW/dashboard.png";
// import ojt from "../../../Images/OJT/dashboard.png";
// import triangleImage from "../../../Images/triangleImage.jpg";
// import logo1 from "../../../Images/LogoWhyUs/logo1.svg";
// import logo2 from "../../../Images/LogoWhyUs/logo2.png";
// import logo3 from "../../../Images/LogoWhyUs/logo3.svg";
// import logo4 from "../../../Images/LogoWhyUs/logo4.svg";
// import logo5 from "../../../Images/LogoWhyUs/logo5.svg";
// import logo6 from "../../../Images/LogoWhyUs/logo6.png";
// import ecommerce from "../../../Images/ecommerce.jpg";
// import manufacture from "../../../Images/manufacture.jpg";
// import moreImage from "../../../Images/moreImages.jpg";
// import tour from "../../../Images/tour.jpg";
import { commonCss } from "../../../CssStyle/commonCss";
import {
  AccountTree,
  AdUnits,
  ArrowForward,
  BackHand,
  CloudSync,
  Create,
  Devices,
  DevicesOther,
  DisplaySettings,
  Diversity1,
  Diversity2,
  EmojiObjects,
  FilterDrama,
  Groups,
  Insights,
  Lan,
  Language,
  Pentagon,
  Psychology,
  Rocket,
  SentimentSatisfiedAltOutlined,
  Layers,
  Backup,
  WbCloudy,
  VpnLock,
} from "@mui/icons-material";
import AutoSlider from "./AutoSlider";
import { common } from "@mui/material/colors";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const boxRef = useRef([]);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = 1;
          entry.target.style.transform = "translateX(0)";
          // entry.target.style.display = "none";
        } else {
          entry.target.style.opacity = 0;
          if (window.innerWidth < 600) {
            entry.target.style.transform = "translateX(100px)";
          } else if (window.innerWidth < 600) {
            entry.target.style.transform = "translateX(300px)";
          } else {
            entry.target.style.transform = "translateX(500px)";
          }

          // entry.target.style.display = "flex";
        }
      },
      {
        rootMargin: "0px 0px -50px 0px", // Triggers earlier
        threshold: 0.1, // Lower threshold for better detection
      }
    );

    if (boxRef.current) {
      observer.observe(boxRef.current);
    }

    return () => {
      if (boxRef.current) {
        observer.unobserve(boxRef.current);
      }
    };
  }, []);

  const ourValues = [
    {
      icon: SentimentSatisfiedAltOutlined,
      title: "Delighted Clients",
      desc: "We prioritize a smooth workflow, but our first and final goal is client satisfaction.",
    },
    {
      icon: Insights,
      title: "Evolution",
      desc: "Every day, we push beyond our comfort zone to evolve, excel, and provide better service.",
    },
    {
      icon: Diversity2,
      title: "Teamwork",
      desc: "Each of us brings strength and skill, but as a team, we become invincible.",
    },
    {
      icon: Pentagon,
      title: "Ethics",
      desc: "Guided by honesty and fairness, our team remains steadfast in upholding our moral compass.",
    },
    {
      icon: BackHand,
      title: "Honesty",
      desc: "Our process is an open book—our clients are engaged in every step from the very beginning.",
    },
  ];

  const industriesServe = [
    {
      img: "/Images/ecommerce.jpg",
      title: "Retail & E-commerce",
      desc: "Online stores, eCommerce apps, pre-ordering, Customer Insights, Customer Analytics…",
    },
    {
      img: "/Images/tour.jpg",
      title: "Travel & Tour Packages",
      desc: "Hotel IBE, Flight IBE, Car IBE, API Integrations, Dynamic Packaging portals, Booking Portals…",
    },
    {
      img: "/Images/manufacture.jpg",
      title: "Manufacturing & Distribution",
      desc: "ERP, Inventory Management, Supply Chain Management, Accounting, Forecasting…",
    },
    {
      img: "/Images/moreImages.jpg",
      title: "& More",
      desc: "Regardless of the industry your business belongs to, we speak your language fluently.",
    },
  ];

  const technology = [
    {
      icon: DevicesOther,
      title: "Front-End",
      list: [
        {
          name: "Angular",
        },
        {
          name: "React",
        },
        {
          name: "Vue",
        },
        {
          name: "Ionic",
        },
        {
          name: "Bootstrap",
        },
      ],
    },
    {
      icon: DisplaySettings,
      title: "Back-End",
      list: [
        {
          name: "NodeJS",
        },
        {
          name: "Python",
        },
        {
          name: "PHP, Laravel",
        },
        {
          name: "Redis",
        },
        {
          name: "PostgreSQL, MySQL, MongoDB",
        },
      ],
    },
    {
      icon: AdUnits,
      title: "Mobile Development",
      list: [
        {
          name: "Hybrid App development",
        },
        {
          name: "Android",
        },
        {
          name: "iOS",
        },
        {
          name: "Ionic",
        },
        {
          name: "Flutter",
        },
      ],
    },
    {
      icon: CloudSync,
      title: "Cloud",
      list: [
        {
          name: "Amazon Web Services",
        },
        {
          name: "Google Cloud Platform",
        },
        {
          name: "Microsoft Azure",
        },
        {
          name: "Digital Ocean",
        },
        {
          name: "Hetzner",
        },
      ],
    },
    {
      icon: AccountTree,
      title: "CI/CD",
      list: [
        {
          name: "Gitlab CI",
        },
        {
          name: "Jenkins CI",
        },
        {
          name: "Github",
        },
        {
          name: "Action",
        },
        {
          name: "Circle CI",
        },
      ],
    },
    {
      icon: Create,
      title: "UI/UX",
      list: [
        {
          name: "Figma",
        },
        {
          name: "Adobe XD",
        },
        {
          name: "Photshop",
        },
        {
          name: "Illustrator",
        },
        {
          name: "Sketch",
        },
      ],
    },
    {
      icon: Psychology,
      title: "AI/ML",
      list: [
        {
          name: "NLP",
        },
        {
          name: "Computer Vision",
        },
        {
          name: "Deep Learning",
        },
        {
          name: "Tensorflow",
        },
        {
          name: "Keras",
        },
      ],
    },
    {
      icon: Lan,
      title: "Blockchain",
      list: [
        {
          name: "NEM Symbol",
        },
        {
          name: "Solidity",
        },
        {
          name: "Hyperledger",
        },
        {
          name: "Binance",
        },
        {
          name: "Ethereum",
        },
      ],
    },
  ];
  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Box
        sx={{
          background: `url(/Images/wave.svg)`,
          backgroundSize: "cover",
          width: "100%",
          height: "100%",
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          zIndex: -1,
        }}
      ></Box>
      <Grid2 container justifyContent={"center"}>
        <Grid2
          size={12}
          container
          justifyContent={"center"}
          alignItems={"center"}
          sx={{
            p: { xs: "1rem", md: "2rem" },
            // mt: { xs: "35%", sm: "30%", md: "20%", lg: "15%", xl: 0 },
            mt:{xs:"13vh",xl:"10vh"},
            maxWidth: { xs: "auto", xl: "2000px" },
            height: { xs: "fit-content", xl: "84vh" },
          }}
        >
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "2rem",
                pl: { xs: 0, md: "1rem" },
              }}
            >
              <Typography
                variant="h2"
                sx={{ fontSize: { xs: "2rem", md: "4rem", fontWeight: 500 } }}
              >
                Striving Towards{" "}
                <span style={{ color: commonCss.orange }}>
                  Excellence & Perfection
                </span>
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "1rem", md: "1.3rem" },
                  fontWeight: 400,
                  color: commonCss.gray,
                }}
              >
                We strongly believe that our technologies will help you achieve
                your goals with more confidence.
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", md: "flex-start" },
                }}
              >
                <Button
                  sx={{
                    backgroundColor: commonCss.buttonBg,
                    color: commonCss.buttonText,
                    padding: "0.5rem",
                    textTransform: "none",
                    width: "40%",
                    fontWeight: 500,
                    fontSize: "0.95rem",
                    borderRadius: "30px",
                    ":hover": {
                      background: commonCss.blue,
                    },
                  }}
                  onClick={() => {
                    navigate("/contactus");
                  }}
                >
                  Contact Us
                </Button>
              </Box>
            </Box>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Box sx={{ mt: { xs: 0, md: "-4rem" } }}>
              <Lottie animationData={HomeAnimation} loop={true} />
            </Box>
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2 container justifyContent={"center"}>
        <Grid2
          size={12}
          container
          justifyContent={"center"}
          sx={{ p: "1rem", maxWidth: { xs: "auto", xl: "2000px" } }}
        >
          <Paper
            elevation={4}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "4rem",
              width: { xs: "100%", md: "90%" },
              flexWrap: "wrap",
              backgroundColor: commonCss.blue,
              padding: { xs: "1rem", md: "5rem 1rem" },
              borderRadius: commonCss.paperRadius,
              mt: { xs: 0, xl: 2 },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                justifyContent: "center",
                alignItems: "center",
                gap: "1.5rem",
              }}
            >
              <Box
                sx={{
                  padding: commonCss.iconBoxPadding,
                  background: commonCss.bgIcon,
                  borderRadius: commonCss.iconBoxRaduis,
                }}
              >
                <EmojiObjects
                  sx={{ color: commonCss.white, fontSize: "4.5rem" }}
                />
              </Box>
              <Box>
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: commonCss.countWeight,
                    color: commonCss.white,
                    textAlign: { xs: "center", md: "left" },
                  }}
                >
                  200+
                </Typography>
                <Typography
                  sx={{
                    color: commonCss.white,
                    fontWeight: commonCss.textWeight,
                    textWrap: "wrap",
                    // fontSize:"0.7rem"
                  }}
                >
                  Future Proof Innovations
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                justifyContent: "center",
                alignItems: "center",
                gap: "1.5rem",
              }}
            >
              <Box
                sx={{
                  padding: commonCss.iconBoxPadding,
                  background: commonCss.bgIcon,
                  borderRadius: commonCss.iconBoxRaduis,
                }}
              >
                <Diversity1
                  sx={{ color: commonCss.white, fontSize: "4.5rem" }}
                />
              </Box>
              <Box>
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: commonCss.countWeight,
                    color: commonCss.white,
                    textAlign: { xs: "center", md: "left" },
                  }}
                >
                  10+
                </Typography>
                <Typography
                  sx={{
                    color: commonCss.white,
                    fontWeight: commonCss.textWeight,
                  }}
                >
                  Happy Clients
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                justifyContent: "center",
                alignItems: "center",
                gap: "1.5rem",
              }}
            >
              <Box
                sx={{
                  padding: commonCss.iconBoxPadding,
                  background: commonCss.bgIcon,
                  borderRadius: commonCss.iconBoxRaduis,
                }}
              >
                <Language sx={{ color: commonCss.white, fontSize: "4.5rem" }} />
              </Box>
              <Box>
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: commonCss.countWeight,
                    color: commonCss.white,
                    textAlign: { xs: "center", md: "left" },
                  }}
                >
                  09+
                </Typography>
                <Typography
                  sx={{
                    color: commonCss.white,
                    fontWeight: commonCss.textWeight,
                  }}
                >
                  Countries
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                justifyContent: "center",
                alignItems: "center",
                gap: "1.5rem",
              }}
            >
              <Box
                sx={{
                  padding: commonCss.iconBoxPadding,
                  background: commonCss.bgIcon,
                  borderRadius: commonCss.iconBoxRaduis,
                }}
              >
                <Groups sx={{ color: commonCss.white, fontSize: "4.5rem" }} />
              </Box>
              <Box>
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: commonCss.countWeight,
                    color: commonCss.white,
                    textAlign: { xs: "center", md: "left" },
                  }}
                >
                  1M+
                </Typography>
                <Typography
                  sx={{
                    color: commonCss.white,
                    fontWeight: commonCss.textWeight,
                  }}
                >
                  Fulfilled Customers
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Grid2>
      </Grid2>
      <Grid2 container justifyContent={"center"}>
        <Grid2
          container
          spacing={"1.5rem"}
          sx={{
            p: { xs: "5rem 1rem", md: "5rem 2rem" },
            maxWidth: { xs: "auto", xl: "2000px" },
          }}
        >
          <Grid2 size={12}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 550,
                textAlign: "center",
                mt: "1rem",
                mb: "0.5rem",
              }}
            >
              Our Services
            </Typography>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: "1.1rem",
                color: commonCss.gray,
                textAlign: "center",
              }}
            >
              Innovative strategies that bring your ideas to action
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, lg: 3 }}>
            <Paper
              elevation={0}
              sx={{
                cursor: "pointer",
                transition: "1s",
                display: "flex",
                p: "1rem",
                height: "100%",
                flexDirection: "column",
                gap: "1rem",
                ":hover": {
                  boxShadow: "0 7px 10px rgb(173, 167, 167)",
                  borderRadius: "7px",
                  transform: "scale(1.1)",
                },
              }}
              onClick={() => {
                navigate("/services?serviceTitle=custom");
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  color: commonCss.orange,
                  fontWeight: commonCss.countWeightCard,
                  textAlign: "center",
                }}
              >
                01
              </Typography>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.5rem",
                  alignItems: "center",
                  color: commonCss.countColor,
                }}
              >
                <AccountTree sx={{ fontSize: "2rem" }} />
                <Typography variant="h6">Custom Solutions</Typography>
              </Box>
              <Typography
                sx={{
                  textAlign: "center",
                  lineHeight: 1.5,
                  color: "black",
                  fontSize: "0.95rem",
                }}
              >
                Offering flexible and customizable software solutions designed
                to meet the needs of businesses across all sectors and scales.
              </Typography>
            </Paper>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, lg: 3 }}>
            <Paper
              elevation={0}
              sx={{
                cursor: "pointer",
                transition: "1s",
                display: "flex",
                p: "1rem",
                flexDirection: "column",
                gap: "1rem",
                height: "100%",
                ":hover": {
                  boxShadow: "0 7px 10px rgb(173, 167, 167)",
                  borderRadius: "7px",
                  transform: "scale(1.1)",
                },
              }}
              onClick={() => {
                navigate("/services?serviceTitle=application");
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  color: commonCss.orange,
                  fontWeight: commonCss.countWeightCard,
                  textAlign: "center",
                }}
              >
                02
              </Typography>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.5rem",
                  alignItems: "center",
                  color: commonCss.countColor,
                }}
              >
                <Devices sx={{ fontSize: "2rem" }} />
                <Typography variant="h6">Applications</Typography>
              </Box>
              <Typography
                sx={{
                  textAlign: "center",
                  lineHeight: 1.5,
                  color: "black",
                  fontSize: "0.95rem",
                }}
              >
                Building scalable and cutting-edge mobile and web applications
                from the ground up, tailored to client specifications.
              </Typography>
            </Paper>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, lg: 3 }}>
            <Paper
              elevation={0}
              sx={{
                cursor: "pointer",
                transition: "1s",
                display: "flex",
                p: "1rem",
                height: "100%",
                flexDirection: "column",
                gap: "1rem",
                ":hover": {
                  boxShadow: "0 7px 10px rgb(173, 167, 167)",
                  borderRadius: "7px",
                  transform: "scale(1.1)",
                },
              }}
              onClick={() => {
                navigate("/services?serviceTitle=oracle");
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  color: commonCss.orange,
                  fontWeight: commonCss.countWeightCard,
                  textAlign: "center",
                }}
              >
                03
              </Typography>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.5rem",
                  alignItems: "center",
                  color: commonCss.countColor,
                }}
              >
                <Layers sx={{ fontSize: "2rem" }} />
                <Typography variant="h6">Oracle Cloud</Typography>
              </Box>
              <Typography
                sx={{
                  textAlign: "center",
                  lineHeight: 1.5,
                  color: "black",
                  fontSize: "0.95rem",
                }}
              >
                Oracle enables global businesses to streamline operations. We deliver integrated solutions that drive efficiency and growth.
              </Typography>
            </Paper>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, lg: 3 }}>
            <Paper
              elevation={0}
              sx={{
                cursor: "pointer",
                transition: "1s",
                display: "flex",
                p: "1rem",
                flexDirection: "column",
                gap: "1rem",
                height: "100%",
                ":hover": {
                  boxShadow: "0 7px 10px rgb(173, 167, 167)",
                  borderRadius: "7px",
                  transform: "scale(1.1)",
                },
              }}
              onClick={() => {
                navigate("/services?serviceTitle=sharepoint");
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  color: commonCss.orange,
                  fontWeight: commonCss.countWeightCard,
                  textAlign: "center",
                }}
              >
                04
              </Typography>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.5rem",
                  alignItems: "center",
                  color: commonCss.countColor,
                }}
              >
                <Backup sx={{ fontSize: "2rem" }} />
                <Typography variant="h6">Sharepoint Cloud</Typography>
              </Box>
              <Typography
                sx={{
                  textAlign: "center",
                  lineHeight: 1.5,
                  color: "black",
                  fontSize: "0.95rem",
                }}
              >
                We provide ongoing SharePoint support to keep your platform running smoothly and securely.
              </Typography>
            </Paper>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, lg: 3 }}>
            <Paper
              elevation={0}
              sx={{
                cursor: "pointer",
                transition: "1s",
                display: "flex",
                p: "1rem",
                height: "100%",
                flexDirection: "column",
                gap: "1rem",
                ":hover": {
                  boxShadow: "0 7px 10px rgb(173, 167, 167)",
                  borderRadius: "7px",
                  transform: "scale(1.1)",
                },
              }}
              onClick={() => {
                navigate("/services?serviceTitle=saleforce");
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  color: commonCss.orange,
                  fontWeight: commonCss.countWeightCard,
                  textAlign: "center",
                }}
              >
                05
              </Typography>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.5rem",
                  alignItems: "center",
                  color: commonCss.countColor,
                }}
              >
                <WbCloudy sx={{ fontSize: "2rem" }} />
                <Typography variant="h6">Salesforce Cloud</Typography>
              </Box>
              <Typography
                sx={{
                  textAlign: "center",
                  lineHeight: 1.5,
                  color: "black",
                  fontSize: "0.95rem",
                }}
              >
                We help businesses implement and customize Salesforce to fit their unique needs.
              </Typography>
            </Paper>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, lg: 3 }}>
            <Paper
              elevation={0}
              sx={{
                cursor: "pointer",
                transition: "1s",
                display: "flex",
                p: "1rem",
                flexDirection: "column",
                gap: "1rem",
                height: "100%",
                ":hover": {
                  boxShadow: "0 7px 10px rgb(173, 167, 167)",
                  borderRadius: "7px",
                  transform: "scale(1.1)",
                },
              }}
              onClick={() => {
                navigate("/services?serviceTitle=cyber");
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  color: commonCss.orange,
                  fontWeight: commonCss.countWeightCard,
                  textAlign: "center",
                }}
              >
                06
              </Typography>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.5rem",
                  alignItems: "center",
                  color: commonCss.countColor,
                }}
              >
                <VpnLock sx={{ fontSize: "2rem" }} />
                <Typography variant="h6">Cybersecurity Service</Typography>
              </Box>
              <Typography
                sx={{
                  textAlign: "center",
                  lineHeight: 1.5,
                  color: "black",
                  fontSize: "0.95rem",
                }}
              >
                we provide end-to-end cybersecurity services that help businesses of all sizes stay protected in an increasingly digital and threat-prone world.
              </Typography>
            </Paper>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, lg: 3 }}>
            <Paper
              elevation={0}
              sx={{
                cursor: "pointer",
                transition: "1s",
                display: "flex",
                p: "1rem",
                height: "100%",
                flexDirection: "column",
                gap: "1rem",
                ":hover": {
                  boxShadow: "0 7px 10px rgb(173, 167, 167)",
                  borderRadius: "7px",
                  transform: "scale(1.1)",
                },
              }}
              onClick={() => {
                navigate("/services?serviceTitle=cloud");
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  color: commonCss.orange,
                  fontWeight: commonCss.countWeightCard,
                  textAlign: "center",
                }}
              >
                07
              </Typography>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.5rem",
                  alignItems: "center",
                  color: commonCss.countColor,
                }}
              >
                <FilterDrama sx={{ fontSize: "2rem" }} />
                <Typography variant="h6">Cloud Solutions</Typography>
              </Box>
              <Typography
                sx={{
                  textAlign: "center",
                  lineHeight: 1.5,
                  color: "black",
                  fontSize: "0.95rem",
                }}
              >
                Enhancing digital transformation with the perfect cloud
                platform, designed around the client’s business demands and
                workload.
              </Typography>
            </Paper>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, lg: 3 }}>
            <Paper
              elevation={0}
              sx={{
                cursor: "pointer",
                transition: "1s",
                display: "flex",
                p: "1rem",
                flexDirection: "column",
                gap: "1rem",
                height: "100%",
                ":hover": {
                  boxShadow: "0 7px 10px rgb(173, 167, 167)",
                  borderRadius: "7px",
                  transform: "scale(1.1)",
                },
              }}
              onClick={() => {
                navigate("/services?serviceTitle=saas");
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  color: commonCss.orange,
                  fontWeight: commonCss.countWeightCard,
                  textAlign: "center",
                }}
              >
                08
              </Typography>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.5rem",
                  alignItems: "center",
                  color: commonCss.countColor,
                }}
              >
                <Rocket sx={{ fontSize: "2rem" }} />
                <Typography variant="h6">SaaS Solutions</Typography>
              </Box>
              <Typography
                sx={{
                  textAlign: "center",
                  lineHeight: 1.5,
                  color: "black",
                  fontSize: "0.95rem",
                }}
              >
                Enhancing business resilience with cutting-edge SaaS solutions,
                simplifying software for clients.
              </Typography>
            </Paper>
          </Grid2>
        
         
          
         
        </Grid2>
      </Grid2>
      <Grid2
        container
        sx={{ backgroundColor: commonCss.backgroundGray, padding: "1rem" }}
        justifyContent={"center"}
      >
        <Grid2 size={12}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 550,
                textAlign: "center",
                mt: "1rem",
                mb: "0.5rem",
              }}
            >
              Our Clients
            </Typography>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: "1.1rem",
                color: commonCss.gray,
                textAlign: "center",
              }}
            >
              Keep Exploring
            </Typography>
          </Grid2>
        <Grid2 sx={{ maxWidth: { xs: "auto", xl: "2000px" } }}>
          <AutoSlider />
        </Grid2>
      </Grid2>
      <Grid2 container justifyContent={"center"}>
        <Grid2
          container
          spacing={"2rem"}
          sx={{
            p: { xs: "5rem 1rem", md: "5rem 2rem" },
            maxWidth: { xs: "auto", xl: "2000px" },
          }}
          justifyContent={"center"}
        >
          <Grid2 size={12}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 550,
                textAlign: "center",
                mt: "1rem",
                mb: "0.5rem",
              }}
            >
              Our Products
            </Typography>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: "1.1rem",
                color: commonCss.gray,
                textAlign: "center",
              }}
            >
              Keep Exploring
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, lg: 4 }}>
            <Paper
              sx={{
                display: "flex",
                alignItems: "center",
                p: "1.5rem",
                height: "100%",
                flexDirection: "column",
                gap: "1rem",
              }}
            >
              <img
                src={"/Images/EAM/Dashboard.png"}
                alt="EAM dashboard"
                style={{ width: "90%", height: { xs: "200px", md: "250px" } }}
              />
              <Button
                sx={{
                  backgroundColor: commonCss.buttonBg,
                  color: commonCss.buttonText,
                  padding: "0.5rem",
                  textTransform: "none",
                  width: "40%",
                  fontWeight: 500,
                  fontSize: "0.95rem",
                  borderRadius: "30px",
                  ":hover": {
                    background: commonCss.blue,
                  },
                }}
                onClick={() => {
                  navigate("/products/eam");
                }}
              >
                Explore
              </Button>
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: "1.5rem",
                  fontWeight: 500,
                }}
              >
                EAM
              </Typography>
              <Typography
                sx={{
                  textAlign: "center",
                  lineHeight: 1.5,
                  color: commonCss.darkGray,
                  fontSize: "0.95rem",
                }}
              >
                Enhancing Psset Performance Through Strategic Lifecycle
                Management.
              </Typography>
            </Paper>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, lg: 4 }}>
            <Paper
              sx={{
                display: "flex",
                alignItems: "center",
                p: { xs: "1rem", md: "1.5rem" },
                height: "100%",
                flexDirection: "column",
                gap: "1rem",
              }}
            >
              <img
                src={"/Images/IPB/image3.png"}
                alt="Internet Booking Platform screenshot"
                style={{ width: "90%", height: { xs: "200px", md: "250px" } }}
              />
              <Button
                sx={{
                  backgroundColor: commonCss.buttonBg,
                  color: commonCss.buttonText,
                  padding: "0.5rem",
                  textTransform: "none",
                  width: "40%",
                  fontWeight: 500,
                  fontSize: "0.95rem",
                  borderRadius: "30px",
                  ":hover": {
                    background: commonCss.blue,
                  },
                }}
                onClick={() => {
                  navigate("/products/ipb");
                }}
              >
                Explore
              </Button>
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: "1.5rem",
                  fontWeight: 500,
                }}
              >
                Internet Booking Platform
              </Typography>
              <Typography
                sx={{
                  textAlign: "center",
                  lineHeight: 1.5,
                  color: commonCss.darkGray,
                  fontSize: "0.95rem",
                }}
              >
                EBook Services And Events Easily With One Powerful Platform.
              </Typography>
            </Paper>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, lg: 4 }}>
            <Paper
              sx={{
                display: "flex",
                alignItems: "center",
                p: "1.5rem",
                height: "100%",
                flexDirection: "column",
                gap: "1rem",
              }}
            >
              <img
                src={"/Images/PTW/dashboard.png"}
                alt="Permit to Work dashboard"
                style={{ width: "90%", height: { xs: "200px", md: "250px" } }}
              />
              <Button
                sx={{
                  backgroundColor: commonCss.buttonBg,
                  color: commonCss.buttonText,
                  padding: "0.5rem",
                  textTransform: "none",
                  width: "40%",
                  fontWeight: 500,
                  fontSize: "0.95rem",
                  borderRadius: "30px",
                  ":hover": {
                    background: commonCss.blue,
                  },
                }}
                onClick={() => {
                  navigate("/products/e_Form");
                }}
              >
                Explore
              </Button>
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: "1.5rem",
                  fontWeight: 500,
                }}
              >
                Permit to work
              </Typography>
              <Typography
                sx={{
                  textAlign: "center",
                  lineHeight: 1.5,
                  color: commonCss.darkGray,
                  fontSize: "0.95rem",
                }}
              >
                Streamlined Digital Permit-To-Work Management System.
              </Typography>
            </Paper>
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, lg: 4 }}>
            <Paper
              sx={{
                display: "flex",
                alignItems: "center",
                p: "1.5rem",
                height: "100%",
                flexDirection: "column",
                gap: "1rem",
              }}
            >
              <img
                src={"/Images/safetyWalk/dashboard.png"}
                alt="Safety Walk dashboard"
                style={{ width: "90%", height: { xs: "200px", md: "250px" } }}
              />
              <Button
                sx={{
                  backgroundColor: commonCss.buttonBg,
                  color: commonCss.buttonText,
                  padding: "0.5rem",
                  textTransform: "none",
                  width: "40%",
                  fontWeight: 500,
                  fontSize: "0.95rem",
                  borderRadius: "30px",
                  ":hover": {
                    background: commonCss.blue,
                  },
                }}
                onClick={() => {
                  navigate("/products/safetywalk");
                }}
              >
                Explore
              </Button>
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: "1.5rem",
                  fontWeight: 500,
                }}
              >
                Safety Walk
              </Typography>
              <Typography
                sx={{
                  textAlign: "center",
                  lineHeight: 1.5,
                  color: commonCss.darkGray,
                  fontSize: "0.95rem",
                }}
              >
                Enhancing Workplace Safety Through Digital Inspections.
              </Typography>
            </Paper>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, lg: 4 }}>
            <Paper
              sx={{
                display: "flex",
                alignItems: "center",
                p: "1.5rem",
                height: "100%",
                flexDirection: "column",
                gap: "1rem",
              }}
            >
              <img
                src={"/Images/e-Form/dashboard.png"}
                alt="Security e-Form dashboard"
                style={{ width: "90%", height: { xs: "200px", md: "250px" } }}
              />
              <Button
                sx={{
                  backgroundColor: commonCss.buttonBg,
                  color: commonCss.buttonText,
                  padding: "0.5rem",
                  textTransform: "none",
                  width: "40%",
                  fontWeight: 500,
                  fontSize: "0.95rem",
                  borderRadius: "30px",
                  ":hover": {
                    background: commonCss.blue,
                  },
                }}
                onClick={() => {
                  navigate("/products/e_Form");
                }}
              >
                Explore
              </Button>
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: "1.5rem",
                  fontWeight: 500,
                }}
              >
                Security e-Form
              </Typography>
              <Typography
                sx={{
                  textAlign: "center",
                  lineHeight: 1.5,
                  color: commonCss.darkGray,
                  fontSize: "0.95rem",
                }}
              >
                A Streamlined Solution For Secure Submission And Management Of
                Security Forms.
              </Typography>
            </Paper>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, lg: 4 }}>
            <Paper
              sx={{
                display: "flex",
                alignItems: "center",
                p: "1.5rem",
                height: "100%",
                flexDirection: "column",
                gap: "1rem",
              }}
            >
              <img
                src={"/Images/OJT/dashboard.png"}
                alt="OJT dashboard"
                style={{ width: "90%", height: { xs: "200px", md: "250px" } }}
              />
              <Button
                sx={{
                  backgroundColor: commonCss.buttonBg,
                  color: commonCss.buttonText,
                  padding: "0.5rem",
                  textTransform: "none",
                  width: "40%",
                  fontWeight: 500,
                  fontSize: "0.95rem",
                  borderRadius: "30px",
                  ":hover": {
                    background: commonCss.blue,
                  },
                }}
                onClick={() => {
                  navigate("/products/ojt");
                }}
              >
                Explore
              </Button>
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: "1.5rem",
                  fontWeight: 500,
                }}
              >
                Online Job Training
              </Typography>
              <Typography
                sx={{
                  textAlign: "center",
                  lineHeight: 1.5,
                  color: commonCss.darkGray,
                  fontSize: "0.95rem",
                }}
              >
                Streamlining employee training for efficiency and growth.
              </Typography>
            </Paper>
          </Grid2>
        </Grid2>
      </Grid2>

      <Grid2
        container
        spacing={{ xs: "1rem", md: "2rem" }}
        sx={{
          p: "5rem 1rem",
          backgroundColor: commonCss.backgroundGray,
          overflowX: "hidden",
        }}
        justifyContent={"center"}
      >
        <Grid2
          container
          justifyContent={"center"}
          sx={{ maxWidth: { xs: "auto", xl: "2000px" } }}
        >
          <Grid2 size={12}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 550,
                textAlign: "center",
                mt: "1rem",
                mb: "0.5rem",
              }}
            >
              Our Values
            </Typography>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: "1.1rem",
                color: commonCss.gray,
                textAlign: "center",
              }}
            >
              Driven by our core values, we make decisions with purpose every
              day.
            </Typography>
          </Grid2>
          <Grid2 container size={12} spacing={"1rem"} justifyContent={"center"}>
            <Box
              ref={boxRef}
              sx={{
                width: "100%",
                display: "flex",
                gap: "1.7rem",
                flexWrap: "wrap",
                justifyContent: { xs: "flex-start", lg: "center" },
                transform: { xs: "translateX(100px)", lg: "translateX(500px)" },
                opacity: 0,
                transition: "transform 0.8s ease-out, opacity 0.8s ease-out",
              }}
            >
              {ourValues.map((values, i) => (
                <Paper
                  elevation={4}
                  key={i}
                  sx={{
                    width: { xs: "100%", md: "48%", lg: "18%" },
                    height: { xs: "fit-content", lg: "100%" },
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                    padding: "1.5rem",
                    color: commonCss.gray,
                    cursor: "pointer",
                    ":hover": {
                      background: commonCss.blue,
                      color: commonCss.white,
                      "& .MuiTypography-h6": {
                        color: commonCss.white,
                      },
                    },
                  }}
                  onClick={() => {
                    navigate("/contactus");
                  }}
                >
                  <values.icon sx={{ fontSize: "2.7rem" }} />
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 600, color: commonCss.darkGray }}
                  >
                    {values.title}
                  </Typography>
                  <Typography sx={{ textWrap: "wrap", fontSize: "0.9rem" }}>
                    {values.desc}
                  </Typography>
                </Paper>
              ))}
            </Box>
            <Grid2
              container
              size={12}
              justifyContent={"center"}
              alignItems={"center"}
              sx={{
                padding: {
                  xs: "3rem 1rem 1rem 1rem",
                  md: "9rem 2rem 1rem 2rem",
                },
              }}
            >
              <Grid2
                container
                size={{ xs: 12, lg: 6 }}
                justifyContent={{ xs: "center", lg: "flex-start" }}
              >
                <Box
                  sx={{
                    position: "relative",
                    width: "600px", // Adjust size
                    height: "400px",
                    clipPath: "polygon(0% 100%, 50% 0%, 100% 100%)", // Triangle shape
                    overflow: "hidden",
                  }}
                >
                  {/* Background Image Layer */}
                  <Box
                    sx={{
                      position: "absolute",
                      width: "100%",
                      height: "100%",
                      backgroundImage: `url(/Images/triangleImage.jpg)`, // Replace with your image
                      backgroundSize: "cover",
                      backgroundPosition: "top",
                    }}
                  />

                  {/* Background Color Overlay */}
                  <Box
                    sx={{
                      position: "absolute",
                      width: "100%",
                      height: "100%",
                      bgcolor: "rgba(10, 102, 194, 0.5)", // Semi-transparent red
                    }}
                  />
                </Box>
              </Grid2>
              <Grid2
                container
                size={{ xs: 12, lg: 6 }}
                justifyContent={{ xs: "center", lg: "flex-start" }}
              >
                <Box
                  sx={{
                    width: { xs: "100%", md: "80%" },
                    display: "flex",
                    flexDirection: "column",
                    gap: "1.5rem",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: 600,
                      textAlign: { xs: "center", md: "left" },
                    }}
                  >
                    Let us calculate the perfect estimate for your project.
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{ textAlign: { xs: "center", md: "left" } }}
                  >
                    Share your project vision with us, and we’ll get back to you
                    in 24 hours.
                  </Typography>
                  <Button
                    sx={{
                      backgroundColor: commonCss.buttonBg,
                      color: commonCss.buttonText,
                      padding: "0.5rem",
                      textTransform: "none",
                      width: { xs: "80%", md: "40%" },
                      fontWeight: 500,
                      fontSize: "0.95rem",
                      borderRadius: "30px",
                      ":hover": {
                        background: commonCss.blue,
                      },
                    }}
                    onClick={() => {
                      navigate("/contactus");
                    }}
                  >
                    Receive a custom estimate
                  </Button>
                </Box>
              </Grid2>
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2 container justifyContent={"center"}>
        <Grid2
          container
          sx={{
            p: { xs: "5rem 1rem", md: "7rem 2rem" },
            maxWidth: { xs: "auto", xl: "2000px" },
          }}
        >
          <Grid2 size={12}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 550,
                textAlign: "center",
                mt: "1rem",
                mb: "0.5rem",
              }}
            >
              WHY us?
            </Typography>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: "1.1rem",
                color: commonCss.gray,
                textAlign: "center",
              }}
            >
              Turning Ideas into Reality, Transforming Possibilities
            </Typography>
          </Grid2>

          <Timeline
            sx={{
              [`& .${timelineItemClasses.root}:before`]: {
                flex: useMediaQuery("(max-width:800px)") ? 0 : 1.025,
                padding: useMediaQuery("(max-width:800px)") ? 0 : 1,
              },
            }}
            position={
              useMediaQuery("(max-width:800px)") ? "right" : "alternate"
            }
          >
            <TimelineItem>
              <TimelineSeparator>
                <TimelineDot
                  sx={{
                    borderWidth: "0.3rem",
                    backgroundColor: commonCss.blue,
                    animation: "blink 2s infinite",
                    "@keyframes blink": {
                      "0%": { opacity: 1 },
                      "50%": { opacity: 0 },
                      "100%": { opacity: 1 },
                    },
                  }}
                />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                  Honors
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  Beyond our fluency in software applications, we are fluent in
                  speaking your language—driven by goals, embracing challenges,
                  valuing uniqueness, taking ownership, maintaining an
                  economical approach, delivering quality, and embedding
                  innovation in everything we do.
                </Typography>
              </TimelineContent>
            </TimelineItem>
            <TimelineItem>
              <TimelineSeparator>
                <TimelineDot
                  sx={{
                    borderWidth: "0.3rem",
                    backgroundColor: commonCss.blue,
                    animation: "blink 2s infinite",
                    "@keyframes blink": {
                      "0%": { opacity: 1 },
                      "50%": { opacity: 0 },
                      "100%": { opacity: 1 },
                    },
                  }}
                />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                  Fluent in Your Needs
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  Our team's excellence and dedication never go unnoticed. Our
                  high client retention rate is a testament to our proven track
                  record and countless success stories.
                </Typography>
              </TimelineContent>
            </TimelineItem>
            <TimelineItem>
              <TimelineSeparator>
                <TimelineDot
                  sx={{
                    borderWidth: "0.3rem",
                    backgroundColor: commonCss.blue,
                    animation: "blink 2s infinite",
                    "@keyframes blink": {
                      "0%": { opacity: 1 },
                      "50%": { opacity: 0 },
                      "100%": { opacity: 1 },
                    },
                  }}
                />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "1rem",
                    flexWrap: "wrap",
                  }}
                >
                  <Box
                    component={"img"}
                    src={"/Images/LogoWhyUs/logo1.svg"}
                    alt="logo"
                    sx={{ width: "20%", height: "20%" }}
                  />
                  <Box
                    component={"img"}
                    src={"/Images/LogoWhyUs/logo2.png"}
                    alt="logo"
                    sx={{ width: "20%", height: "20%" }}
                  />
                  <Box
                    component={"img"}
                    src={"/Images/LogoWhyUs/logo3.svg"}
                    alt="logo"
                    sx={{ width: "20%", height: "20%" }}
                  />
                  <Box
                    component={"img"}
                    src={"/Images/LogoWhyUs/logo4.svg"}
                    alt="logo"
                    sx={{ width: "20%", height: "20%" }}
                  />
                  <Box
                    component={"img"}
                    src={"/Images/LogoWhyUs/logo5.svg"}
                    alt="logo"
                    sx={{ width: "20%", height: "20%" }}
                  />
                  <Box
                    component={"img"}
                    src={"/Images/LogoWhyUs/logo6.png"}
                    alt="logo"
                    sx={{ width: "20%", height: "20%" }}
                  />
                </Box>
              </TimelineContent>
            </TimelineItem>
            <TimelineItem>
              <TimelineSeparator>
                <TimelineDot
                  sx={{
                    borderWidth: "0.3rem",
                    backgroundColor: commonCss.blue,
                    animation: "blink 2s infinite",
                    "@keyframes blink": {
                      "0%": { opacity: 1 },
                      "50%": { opacity: 0 },
                      "100%": { opacity: 1 },
                    },
                  }}
                />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                <Box>
                  <Typography variant="h4" sx={{ width: "fit-content" }}>
                    Our Engagement Models
                  </Typography>
                  <Box sx={{ mt: "2rem" }}>
                    <Typography variant="h5" sx={{ fontWeight: 600 }}>
                      Scalable Offshore Development
                    </Typography>
                    <Typography sx={{ mt: 2 }}>
                      Powered by agile methodology, we craft custom software
                      solutions tailored to accelerate your business
                      goals—making success simpler and more achievable for you.
                    </Typography>
                  </Box>
                  <Box sx={{ mt: "2rem" }}>
                    <Typography variant="h5" sx={{ fontWeight: 600 }}>
                      Let’s Build Success Together
                    </Typography>
                    <Typography sx={{ mt: 2 }}>
                      Enhance your in-house team with our tech experts or
                      dedicated specialists—scaling when and where needed to
                      tackle complex projects with quality and precision.
                    </Typography>
                  </Box>
                </Box>
              </TimelineContent>
            </TimelineItem>
          </Timeline>
        </Grid2>
      </Grid2>
      <Grid2 container justifyContent={"center"}>
        <Grid2
          container
          spacing={"2rem"}
          sx={{
            p: { xs: "3rem 1rem", md: "5rem 2rem" },
            backgroundColor: commonCss.backgroundGray,
            maxWidth: { xs: "auto", xl: "2000px" },
          }}
        >
          <Grid2 size={12} sx={{ mb: "2.5rem" }}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 550,
                textAlign: "center",
                mt: "1rem",
                mb: "0.5rem",
              }}
            >
              Industries We Serve
            </Typography>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: "1.1rem",
                color: commonCss.gray,
                textAlign: "center",
              }}
            >
              Driving success from emerging startups to corporate powerhouses
            </Typography>
          </Grid2>
          {industriesServe.map((serve, i) => (
            <Grid2 key={i} size={{ xs: 12, md: 6, lg: 3 }}>
              {/* <Box component={"img"} src={serve.img} alt="retail" sx={{borderRadius:"20px",width:"100%"}}/>
          <Box sx={{p:"1rem", position:"absolute",
              top:{xs:"10vh",sm:""}}}>
                    <Paper
          elevation={3}
            sx={{
             
              borderRadius:"20px",
              cursor: "pointer",
              display: "flex",
              p: "1.2rem",
              // height: "100%",
              flexDirection: "column",
              gap: "1.5rem",
              ":hover": {
               color:commonCss.white,
               backgroundColor:commonCss.blue
              },
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: commonCss.countWeightCard,
                 position: "relative",
                           pt: "15px",
                              "::before": {
                                content: '""',
                                position: "absolute",
                                top: 0,
                                left: 0,
                                bottom:0,
                                width: "20%",
                                height: "3px",
                                backgroundColor: commonCss.orange,
                              },
              }}
            >
              {serve.title}
            </Typography>
          
            <Typography
              sx={{
                lineHeight: 1.5,
                
                fontSize: "0.95rem",
              }}
            >
              {serve.desc}
                                    
            </Typography>
            <ArrowForward/>
          </Paper>
          </Box> */}
              <Card
                elevation={3}
                sx={{
                  cursor: "pointer",
                  height: "100%",
                  borderRadius: "20px",
                  ":hover": {
                    color: commonCss.white,
                    backgroundColor: commonCss.blue,
                  },
                }}
                onClick={() => {
                  navigate("/contactus");
                }}
              >
                <CardActionArea>
                  <CardMedia
                    component="img"
                    height="200"
                    image={serve.img}
                    alt="industries_serve"
                  />
                  <CardContent
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "1.5rem",
                      borderRadius: "20px",
                    }}
                  >
                    <Typography
                      variant="h5"
                      sx={{
                        fontWeight: commonCss.countWeightCard,
                        position: "relative",
                        pt: "15px",
                        "::before": {
                          content: '""',
                          position: "absolute",
                          top: 0,
                          left: 0,
                          bottom: 0,
                          width: "20%",
                          height: "3px",
                          backgroundColor: commonCss.orange,
                        },
                      }}
                    >
                      {serve.title}
                    </Typography>
                    <Typography
                      sx={{
                        lineHeight: 1.5,

                        fontSize: "0.95rem",
                      }}
                    >
                      {serve.desc}
                    </Typography>
                  </CardContent>
                </CardActionArea>
                <CardActions>
                  <ArrowForward />
                </CardActions>
              </Card>
            </Grid2>
          ))}
        </Grid2>
      </Grid2>
      <Grid2 container justifyContent={"center"}>
        <Grid2
          container
          spacing={"1.5rem"}
          sx={{ p: "5rem 2rem", maxWidth: { xs: "auto", xl: "2000px" } }}
        >
          <Grid2 size={12} sx={{ mb: "2.5rem" }}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 550,
                textAlign: "center",
                mt: "1rem",
                mb: "0.5rem",
              }}
            >
              Technology Expertise
            </Typography>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: "1.1rem",
                color: commonCss.gray,
                textAlign: "center",
              }}
            >
              Bringing ideas to life with skill and creativity .
            </Typography>
          </Grid2>
          {technology.map((tech, i) => (
            <Grid2 key={i} container size={{ xs: 12, md: 6, lg: 3 }}>
              <Grid2 size={3}>
                <tech.icon
                  sx={{ fontSize: "3rem", color: commonCss.darkGray }}
                />
              </Grid2>
              <Grid2 size={9}>
                <Typography variant="h6" sx={{ fontWeight: 500 }}>
                  {tech.title}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.5rem",
                    mt: "1rem",
                  }}
                >
                  {tech.list.map((techlist, index) => (
                    <Typography
                      key={index}
                      sx={{
                        fontSize: "0.9rem",
                        pb: "0.5rem",
                        borderBottom: `1px solid #e6e6e6`,
                      }}
                    >
                      {techlist.name}
                    </Typography>
                  ))}
                </Box>
              </Grid2>
            </Grid2>
          ))}
        </Grid2>
      </Grid2>
      {/* <Grid2 container justifyContent={"center"}> */}
      <Grid2
        container
        sx={{ p: { xs: "1rem", md: "2rem" } }}
        justifyContent={"center"}
      >
        <Paper
          elevation={3}
          sx={{
            width: { xs: "100%", md: "70%" },
            backgroundColor: "#08529b",
            position: "relative",
            padding: { xs: "1rem", md: "4rem 2rem" },
            borderRadius: "20px",
          }}
        >
          <Box>
            {" "}
            <Lottie
              animationData={contactusHomePage}
              loop={true}
              style={{
                position: "absolute",
                zIndex: 0,
                top: "-50%",
                width: "100%",
                bottom: 0,
                left: 0,
                right: 0,
                opacity: 0.5,
              }}
            />
          </Box>

          <Box
            sx={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <Box
              sx={{
                padding: { xs: 0, md: "2rem" },
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "1.5rem",
                width: { xs: "100%", md: "75%" },
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  color: commonCss.white,
                  textAlign: "center",
                  zIndex: 9,
                  fontSize: { xs: "40px", md: "48px" },
                }}
              >
                Explain your project to us.
              </Typography>
              <Typography
                sx={{
                  color: commonCss.white,
                  textAlign: "center",
                  zIndex: 9,
                  fontSize: "1.2rem",
                }}
              >
                We’ll be in touch within 24 hours.
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  p: 0.5,
                  zIndex: 9,
                  justifyContent: "space-between",
                  backgroundColor: "white",
                  borderRadius: "30px",
                  width: "100%",
                }}
                onClick={() => {
                  navigate("/contactus");
                }}
              >
                <Typography
                  sx={{
                    width: "80%",
                    color: commonCss.gray,
                    ml: "1.5rem",
                    fontSize: { xs: "1rem", md: "1.2rem" },
                  }}
                >
                  {" "}
                  Let’s talk about the area of your project.
                </Typography>
                <Button
                  sx={{
                    backgroundColor: commonCss.buttonBg,
                    color: commonCss.buttonText,
                    padding: "1rem",
                    textTransform: "none",
                    width: { xs: "25%", md: "20%" },
                    fontWeight: 500,
                    fontSize: "0.95rem",
                    borderRadius: "30px",
                    ":hover": {
                      background: commonCss.blue,
                    },
                  }}
                >
                  Send
                </Button>
              </Box>
            </Box>
          </Box>
        </Paper>
      </Grid2>
      {/* </Grid2> */}
    </Box>
  );
};

export default Home;
